import { FC, useContext } from "react";
import styles from "./styles.scss";
import itemStyles from "./side-navigation-item/styles.scss";
import { CompanyLogo } from "@/components";
import { navigationConfig } from "@/routes";
import { SideNavigationItem } from "@/components/side-navigation/side-navigation-item";
import { AuthContext } from "@/guards/auth/auth-context";
import { Logout } from "@/assets/icons";

export const SideNavigation: FC = () => {
  const { logout } = useContext(AuthContext);

  return (
    <div className={styles.sideNavWrapper}>
      <div className={styles.container}>
        <div>
          <CompanyLogo className={styles.logo} />
        </div>
        <div className={styles.list}>
          {navigationConfig.map(
            ({ iconElement, iconElementActive, path, title }) => (
              <SideNavigationItem
                key={title}
                iconElement={iconElement}
                iconElementActive={iconElementActive}
                path={path}
                title={title}
              />
            ),
          )}
        </div>
        <div className={itemStyles.listItem} onClick={logout}>
          <div className={itemStyles.listItemIconWrapper}>
            <Logout className={itemStyles.listItemIcon} />
          </div>
          <p className={itemStyles.listItemTitle}>Log Out</p>
        </div>
      </div>
    </div>
  );
};
